import React from "react";
import { FiArrowLeft, FiLock } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import logo from "./assets/hallef-logo-cropped.png";
import "./permission-denied.css";

export default function PermissionDenied() {
  const navigate = useNavigate();

  return (
    <main className="permission-page">
      <img className="permission-logo" src={logo} alt="Hallef Technologies" />
      <section className="permission-card" aria-labelledby="permission-title">
        <div className="permission-icon"><FiLock aria-hidden="true" /></div>
        <p className="permission-eyebrow">ACCESS RESTRICTED</p>
        <h1 id="permission-title">Permission denied</h1>
        <p className="permission-description">
          You don’t have permission to view this page. If you think you should have access, contact your administrator.
        </p>
        <button className="permission-back" type="button" onClick={() => navigate(-1)}>
          <FiArrowLeft aria-hidden="true" /> Go back
        </button>
      </section>
      <p className="permission-footer">Hallef Technologies <span aria-hidden="true">·</span> Access support</p>
    </main>
  );
}
